import { Bot, Sparkles, X, RotateCcw } from "lucide-react";
import { useDraggablePosition } from "@/lib/useDraggablePosition";

export function ChatbotLauncher({ onOpen }) {
  const { offset, dragProps, reset, moved } = useDraggablePosition("chatbot");
  return (
    <div
      className="fixed bottom-4 left-4 z-50"
      // The anchor sits at bottom-left. Positive offset.x moves AWAY from
      // the left anchor (i.e. to the right); positive offset.y moves UP.
      style={{ transform: `translate3d(${offset.x}px, ${-offset.y}px, 0)` }}
    >
      <div className="relative group">
        {moved && (
          <button
            type="button"
            onClick={reset}
            data-no-drag
            className="absolute -top-2 -right-2 z-10 rounded-full bg-rp-bg border border-rp-border p-1 opacity-0 group-hover:opacity-100 transition-opacity"
            aria-label="Reset chatbot launcher position"
            data-testid="chatbot-launcher-reset"
          >
            <RotateCcw className="h-3 w-3 text-rp-textFaint" />
          </button>
        )}
        <button
          type="button"
          onClick={onOpen}
          {...dragProps}
          className="flex items-center gap-2 rounded-full bg-gradient-to-br from-emerald-500 to-teal-600 hover:from-emerald-400 hover:to-teal-500 text-white px-4 py-3 shadow-lg shadow-emerald-900/40 font-semibold text-sm transition-all hover:scale-105 select-none"
          data-testid="chatbot-launcher"
          aria-label="Open RiskPedia chatbot"
        >
          <Bot className="h-5 w-5" />
          <span className="hidden sm:inline">Ask RiskPedia</span>
        </button>
      </div>
    </div>
  );
}

export function ChatbotChaseBubble({ onOpen, onDismiss }) {
  return (
    <div
      className="fixed bottom-20 left-4 z-50 max-w-xs rounded-2xl border border-emerald-500/40 bg-rp-surface p-4 shadow-2xl shadow-emerald-900/30 animate-fade-in"
      data-testid="chatbot-chase-bubble"
    >
      <button
        type="button"
        onClick={onDismiss}
        className="absolute top-2 right-2 rounded-full p-1 hover:bg-rp-bg"
        aria-label="Dismiss"
        data-testid="chatbot-chase-dismiss"
      >
        <X className="h-3 w-3 text-rp-textFaint" />
      </button>
      <div className="flex items-start gap-2 mb-2">
        <Sparkles className="h-5 w-5 text-emerald-400 shrink-0 mt-0.5" />
        <div>
          <div className="text-sm font-semibold text-rp-text">Wait — before you go!</div>
          <div className="text-xs text-rp-textDim mt-1">
            Got a quick GRC, compliance, or risk question? Our AI mentors answer in seconds — no signup needed.
          </div>
        </div>
      </div>
      <button
        type="button"
        onClick={onOpen}
        className="mt-2 w-full rounded-lg bg-emerald-500 hover:bg-emerald-400 text-white text-xs font-semibold py-2 transition-colors"
        data-testid="chatbot-chase-open"
      >
        Ask a question now →
      </button>
    </div>
  );
}
